/* eslint-disable import/prefer-default-export */
import type {
  AccountInfo,
  CloudTypeEnum,
  SubOrganizationInfo
} from '@src/endpoints/services/base.service'
import type {
  OrganizationDetail,
  SourceDetail
} from '@src/endpoints/services/commonHdr.service'
export * from './edit.transfer.model'
export type Account = AccountInfo & {
  progress?: number
}

export enum SnapshotEnum {
  LAST_SNAPSHOT = 'LAST_SNAPSHOT',
  HISTORY = 'HISTORY'
}

export type FilterScopeAccountsType = 'all' | 'selected' | 'deselected'
export interface FilterScopeAccountsOption {
  label: string
  value: FilterScopeAccountsType
}

export type FilterScopeAccountsOptions = {
  [key: string]: FilterScopeAccountsOption
}

export interface AccountModel extends AccountInfo {
  accountId?: string
  accountName?: string
  checked?: boolean
  parentAccountId?: string
}

export interface SubOrgModel extends SubOrganizationInfo {
  organizationId?: string
  suborganizationName?: string
  suborganizationId?: string
  subOrgs?: { [key: string]: SubOrgModel }
  accounts?: { [key: string]: AccountModel }
  topLevel?: boolean
  checked?: boolean
  indeterminate?: boolean
  selectedAccounts?: number
  totalAccounts?: number
}

export interface SummaryParams {
  cloud_type: CloudTypeEnum
  page: SnapshotEnum
}

export interface Description {
  label: string
  value: React.ReactNode
}

export interface ActionProps<T> {
  onClick: (props?: T) => void
  title: string
  disabled?: boolean | ((item: T) => boolean)
  description?: React.ReactNode | ((item: T) => React.ReactNode)
}

export enum StatusEnum {
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

export interface ErrorState {
  account: JSX.Element
  details: JSX.Element
  status: JSX.Element
}

export interface SnapshotItem {
  organizations?: OrganizationDetail
  sources?: SourceDetail
  isNewAccount?: boolean
  isNewOrg?: boolean
  isOrgActive?: boolean
  name?: string
  id?: string
  isWarning?: boolean
  isActive?: boolean
  isError?: boolean
  cloud_type?: CloudTypeEnum
  resourceCount?: number
  progress?: number
  messages?: {
    [key: string]: {
      status: StatusEnum
      name: string
      message: string
    }
  }
  countAccounts?: number
  countWarnings?: number
  countErrors?: number
  currentPhase?: string
  currentPhaseEnum?: string
  type?: 'account' | 'organization'
  runBy?: string
}
